<template>
  <div>
    <zone-final id="thermostat" v-if="zone.final"></zone-final>
    <zone-container v-else></zone-container>

    <div v-if="zone.final && orderedDevices" class="columns deviceContainer">
      <div
        class="column is-1"
        style="cursor: pointer; position: relative"
        @click="loadDevice(device)"
        v-for="device in orderedDevices"
        :key="device.serialNumber"
      >
        <lottie
          v-if="device.data.status_warming === 1"
          :options="fuzzyResistanceActive"
          :animCreated="handleAnimation"
          :styles="{
            'border-radius': '50px',
            'background-color': 'white',
            height: '25px',
            width: '25px',
            overflow: 'hidden',
            padding: '3px',
            position: 'absolute',
            top: '5px',
            right: '35px',
          }"
        />

        <lottie
          v-if="device.data.status_warming === 2"
          :options="fuzzyLogicActive"
          :animCreated="handleAnimation"
          :styles="{
            'border-radius': '50px',
            'background-color': 'white',
            height: '25px',
            width: '25px',
            overflow: 'hidden',
            padding: '3px',
            position: 'absolute',
            top: '5px',
            right: '35px',
          }"
        />

        <div
          class="deviceCircle"
          v-bind:class="
            getDeviceTemperatureColorBackground(device, device.data.schedule)
          "
        >
          <div v-if="!device.data.power">
            <font>Off</font>
          </div>

          <div v-else-if="device.data.mode === 'auto'" class="zone-temp">
            <div v-if="autoMode(device) === 'O'">
              <div v-if="device.data.ice_mode">
                {{ Math.floor(autoTemp(device)) }}
                <span v-if="!isInt(autoTemp(device))" class="decimal">.5</span>
                <span class="scale-decimal">º </span>
              </div>

              <font v-else>off</font>
            </div>

            <div v-else>
              {{ Math.floor(autoTemp(device)) }}
              <span v-if="!isInt(autoTemp(device))" class="decimal">.5</span>
              <span class="scale-decimal">º </span>
            </div>
          </div>

          <p v-else-if="device.data.power" class="zone-temp">
            {{ Math.floor(device.data.temp)
            }}{{ !isInt(device.data.temp) ? ".5º" : "" }}
          </p>
          <p class="zone-temp" v-else>{{ $t("thermostat.off") }}</p>
        </div>
        <p style="margin-top: 5px">{{ device.data.name }}</p>
      </div>

      <h2
        class="title"
        v-if="orderedDevices.length === 0"
        style="text-align: center; width: 100%"
      >
        {{ $t("zone.noDevices") }}
      </h2>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ZoneContainer from "../../../../components/installations/zones/container/ZoneContainer";
import ZoneFinal from "../../../../components/installations/zones/final/ZoneFinal";
import colors from "@/mixins/colors";
import zapp from "@/util/zapp";
import { EventBus } from "../../../../util/event-bus";
import constants from "../../../../config/constants";
import * as timezones from "@/util/timezones.json";
import moment from "moment-timezone";

import Lottie from "../../../../components/Lottie/Lottie.vue";
import * as LogicActive from "../../../../../public/Fuzzy_logic_activo_Lottie.json";
import * as ResistanceActive from "../../../../../public/resistencia_activa_lottie.json";

export default {
  components: {
    Lottie,
    ZoneFinal,
    ZoneContainer,
  },
  mixins: [colors],
  name: "zone",
  props: {
    idZone: String,
  },
  data() {
    return {
      isActiveModal: false,
      orderedDevices: [],
      constants: constants,
      fuzzyLogicActive: { animationData: LogicActive },
      fuzzyResistanceActive: { animationData: ResistanceActive },
      animationSpeed: 1,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
      tariff: "currentTariff",
    }),

    ...mapState("zones", {
      zone: "current",
      devices: "devices",
    }),

    isFloor: function () {
      return this.zone.type === constants.zoneTypes.floor;
    },
  },
  methods: {
    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapMutations("zones", {
      setStateZone: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
    }),

    ...mapActions("devices", {
      getDeviceSchedule: "getDeviceSchedule",
    }),

    handleAnimation: function (anim) {
      this.anim = anim;
    },

    autoMode: function (device) {
      let tz = timezones.default.find(
        (tz) => tz.value === this.installation.timeZoneId
      );
      if (!tz) {
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        timezones.default.every((ti) => {
          let myUtc = ti.utc.find((utc) => utc === timezone);
          if (myUtc) {
            tz = ti;
            return false;
          }
          return true;
        });
      }
      let date = moment.utc().tz(tz.utc[0]);
      let currentDay = date.day() > 0 ? date.day() - 1 : 6;
      let currentHour = date.hour();
      return device.data.schedule[currentDay].charAt(currentHour);
    },

    autoTemp: function (device) {
      switch (this.autoMode(device)) {
        case "O":
          return device.data.ice;
        case "C":
          return device.data.comfort;
        case "E":
          return device.data.eco;
      }
    },

    loadZone: function () {
      this.setInstallation(this.$route.params.id)
        .then(() => {
          this.setZone(this.idZone).then(() => {
            this.loadDevices();
          });
        })
        .catch(() => {
          this.$router.push("/installations");
        });
    },
    loadDevice: function (device) {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
          "/device/" +
          device.serialnumber
      );
    },
    toggleModal: function () {
      this.isActiveModal = !this.isActiveModal;
    },
    isInt: (n) => zapp.isInt(n),

    loadDevices: function () {
      this.orderedDevices = [...this.devices].sort((a, b) =>
        a.data.name.localeCompare(b.data.name)
      );
    },

    goToStatistics: function () {
      let hasTariff = this.tariff.filter((hour) => hour > 0).length > 0;

      if (hasTariff) {
        this.$router.push(
          "/installations/" +
            this.installation[".key"] +
            "/zone/" +
            this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
            "/statistics"
        );
      } else {
        this.$dialog.alert(this.$t("statistics.noTariff"));
      }
    },
  },

  watch: {
    idZone: function () {
      this.loadZone();
    },
    devices: function () {
      this.loadDevices();
    },
  },

  mounted() {
    this.loadZone();
    EventBus.$on("deviceUpdate", () => {
      this.loadDevices();
    });
  },
  beforeDestroy() {
    this.setStateZone({});
  },
};
</script>

<style lang="scss" scoped>
.is-main-content {
  overflow-y: hidden;
}

.is-main-content > div {
  height: calc(100% - 0.97rem);
}

.columns {
  margin-left: 0;
  margin-right: 0;
}

.zoneContainer {
  height: 100%;
}

.deviceContainer {
  margin-top: 2.5rem;
  min-height: 8.5rem;
}

.deviceCircle {
  color: white;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  margin: 0 auto;
  padding-top: 1.3rem;
}

.button-rounded {
  height: 4em;
  width: 4em;
  border-radius: 50%;
}

.addZone {
  height: 4rem;
  width: 4rem;
  /*background-color: rgba(246, 244, 244, 0.91);*/
  background-color: #ffffff;
  margin-left: 2em;
  border: 1px solid transparent;
  margin-top: 0.8em;

  .icon i::before {
    font-size: 2em;
  }
}

@media screen and (max-width: 1087px) {
  .optionsContainer {
    margin-top: 0;
  }
}
</style>
